const s = (n, e = 0.8, t = 240) => {
  var r;
  return n ? o(
    ((r = window.getComputedStyle(n, null)) == null ? void 0 : r.getPropertyValue("transition-duration")) || ".3s"
  ) * e : t;
}, o = (n) => n.indexOf("s") !== n.length - 1 ? 0 : n.includes("ms") ? parseInt(n.replace("ms", ""), 10) : parseFloat(n.replace("s", "")) * 1e3;
export {
  s as getTransitionDuration,
  o as timeStringToNumber
};
